:host {
  display: block;
  max-width: 100%;
}

gz-collapsable-container::part(button-show-more) {
  --button-text-transform: none;
  justify-content: end;
  margin: 0;
}

gz-labeled-content {
  --label-width-percentage: 20%;
  --value-width-percentage: 80%;

  &::part(container) {
    align-items: center;
  }

  &::part(label) {
    font-size: var(--body-size-small);
  }

  &::part(content) {
    margin-top: -4px;
  }
}

.item-description {
  color: var(--main-titles-inputs-600);
}

.content-labeled-component {
  max-width: 100%;
}
